/**
 * @author Webkul Software Private Limited
 */

define('WeltPixel_OwlCarouselSlider/js/wishlist',[
    "jquery",
    'mage/url',
    'Magento_Customer/js/customer-data'
], function($, urlBuilder, customerData) {
    "use strict";
    return function (config) {
        var wishlistCollection =  customerData.get('wishlist')();
        _.each(wishlistCollection.items, function(item) {
            var pidElem = $('#product_addtocart_form input[name="product"]');
            if (item.product_id == config.productId
                || (pidElem.length && item.product_id == pidElem.val())) {
                var wishlist = document.getElementById(item.product_id);
                var wElement = $(".wl-" + item.product_id);
                wElement.addClass('wishlisted');
                var url = urlBuilder.build("customer/wishlist/remove");
                wElement.removeAttr("data-action");
                wElement.removeAttr("data-post");
                wElement.attr("href", url + "/item/" + item.wishlist_item_id);
            }
        });
    }
});

